package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun BillSearchComponent(
    windowSizeMode: WindowSizeModeEnum,
    statisticData: List<BillSearchStatisticDataItem>?,
    selectedBillSearchStatisticItem: BillSearchStatisticDataItem?,
    onSelectStatisticItem: (BillSearchStatisticDataItem) -> Unit,
    searchBillSearchItems: (String) -> Unit,
    getBillPdf: (String,String,String) -> Unit,
    exportStatisticReports:(List<BillSearchStatisticDataItem>?)->Unit,
)
{
    Column(
        modifier = Modifier
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .fillMaxWidth()
            .showContentInOnePage()
            .fillMaxHeight()
    )
    {
        BillSearchTableContent(
            modifier = Modifier,
            windowSizeMode=windowSizeMode,
            statisticData = statisticData,
            selectedBillSearchStatisticItem =selectedBillSearchStatisticItem,
            onSelectStatisticItem = {
                onSelectStatisticItem(it)
            },
            searchBillSearchItems = {
                searchBillSearchItems(it)
            },
            getBillPdf = {number:String,dateTime:String,cashRegisterId:String->
                getBillPdf(
                    number,
                    dateTime,
                    cashRegisterId,
                )
            },
            exportStatisticReports = {
                exportStatisticReports(it)
            }

        )

        if (selectedBillSearchStatisticItem!=null)
        {
            SelectedBillSearchItemDetailContent(
                modifier = Modifier,
                selectedBillSearchItem = selectedBillSearchStatisticItem,
            )
        }


    }


}



